
.select {
  display: inline-flex;
  position: relative;
  user-select: none;
  overflow: visible;
}

.invalid {
  border: 1px solid var(--sentiment-text-negative) !important;
}

.button {
  height: 100%;
}
.button:focus {
  border-color: var(--primary-enabled);
  outline: none;
}

.fullWidth {
  width: 100%;
}

.buttonContent {
  min-width: min-content;
  white-space: nowrap;
}

.dropdown {
  isolation: isolate;
  overflow-y: auto;
  overflow-x: hidden;
  background-color: var(--static-background-weak);
  border: 1px solid var(--static-divider-standard);
  border-radius: 10px;
  box-shadow: var(--box-shadow);
}

.dropdown:not(.open):not(.closing) {
  max-width: 0 !important;
}

@keyframes show {
  0% {
    opacity: 0;
    transform: translateY(-10px);
  }
  100% {
    opacity: 1;
    transform: none;
  }
}

@keyframes hide {
  0% {
    opacity: 1;
    transform: none;
  }
  100% {
    opacity: 0;
    transform: translateY(-10px);
  }
}

.dropdown.open {
  animation: show 100ms ease forwards;
}
.dropdown.closing {
  animation: hide 100ms ease forwards;
}

.dropdownDisabled {
  z-index: 999;
  isolation: isolate;
  min-width: max-content;
  top: 100%;
  width: 100%;
  max-height: min(1000%, 50vh);
  overflow-y: auto;
  color: lightgray;
  padding: 10px;
}

.dropdownItem {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  margin: 5px;
  padding: 8px;
  border-radius: 10px;
}

.dropdownItemSelected {
  background-color: var(--selectable-selected);
}

.dropdownItem:hover {
  cursor: pointer;
  background-color: var(--selectable-hover);
}

.noHover:hover {
  background-color: unset;
}
